import React, { useRef, useState } from 'react';
import { CAROUSAL_CONFIG } from '../Constants/PastOrderConstants';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import ReorderComponent from 'organisms/ReorderComponent/Container/ReorderComponent';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'molecules/Modal';
import ReceiptComponent from 'organisms/AccountPage/Presentation/ReceiptComponent';
import { resetBasketAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { getPostOrderAccepted } from '@kfc-global/react-shared/redux/Actions/PostOrderAction';
import { getReorderStoreStatus } from '@kfc-global/react-shared/redux/Actions/ReorderAction';
import _first from 'lodash/first';
import _get from 'lodash/get';
import SampleArrowNext from 'organisms/OffersAndPromotions/Presentation/SampleArrowNext';
import SampleArrowPrev from 'organisms/OffersAndPromotions/Presentation/SampleArrowPrev';
import { ChannelManager } from 'common/manager';
import { getTernaryValue } from 'common/utilities/utils';
import PastOrderCardComponentIn from './PastOrderCardComponentIn';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';

function getMergerdOrders(pastOrdersData, favouriteOrders) {
  return [
    ...pastOrdersData?.slice()?.filter(o => favouriteOrders.find(f => f.id === o.id) === undefined),
    ...favouriteOrders,
  ];
}

const PastOrderListComponent = props => {
  const { pastOrdersData, tenantReducerData, favouriteOrders = [] } = props;
  const [currentSlide, updateCurrentSlide] = useState(0);
  const [showReceiptModal, setReceiptModalOpen] = useState(false);
  const [isQuickReorderModalOpen, setQuickReorderModalOpen] = useState(false);
  const [storeInfo, setStoreInfo] = useState({});
  const [currentOrderInfo, setCurrentOrderInfo] = useState({});
  const carousal = useRef(null);
  const { SPEED, SLIDES_TO_SHOW, SLIDES_TO_SCROLL, BREAKPOINT, SLIDES_TO_SCROLL_MOBILE } = CAROUSAL_CONFIG;
  const [reorderModalOpen, setReorderModalOpen] = useState(false);
  const [rangeValue, updateRangeValue] = useState(0);
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const dispatch = useDispatch();

  const { tenantReducer, profileReducer, cartReducer, postOrderReducer } = useSelector(data => data);
  const { tenantId } = tenantReducer;
  const { orderAccepted: orderDetails = {} } = postOrderReducer || {};
  const { customerId } = profileReducer;
  const { cartData = {} } = cartReducer;
  const sortData = getMergerdOrders(pastOrdersData, favouriteOrders).sort(
    (x, y) => y.fulfillmentDateTime - x.fulfillmentDateTime,
  );

  const onNextCard = () => {
    if (currentSlide < sortData.length - 1) {
      let updatedCurrentSlide = 0;
      if (currentSlide + SLIDES_TO_SCROLL > sortData.length - SLIDES_TO_SHOW - 1) {
        updatedCurrentSlide = sortData.length - SLIDES_TO_SHOW;
      } else {
        updatedCurrentSlide = currentSlide + SLIDES_TO_SCROLL;
      }
      updateCurrentSlide(updatedCurrentSlide);
      carousal.current.slickGoTo(updatedCurrentSlide);
    }
  };

  /* OnClicking Previous Arrow Button */
  const onPrevCard = () => {
    if (currentSlide > 0) {
      updateCurrentSlide(currentSlide - SLIDES_TO_SCROLL);
      carousal.current.slickGoTo(currentSlide - SLIDES_TO_SCROLL);
    }
  };

  const onUpdateRange = e => {
    updateRangeValue(e.target.value);
    carousal.current.slickGoTo(e.target.value);
  };

  const settingsRecommendation = {
    dots: false,
    infinite: false,
    speed: SPEED,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: true,
    adaptiveHeight: false,
    autoplay: false,
    nextArrow: <SampleArrowNext clickNextCard={onNextCard} />,
    prevArrow: <SampleArrowPrev clickPrevCard={onPrevCard} />,
    beforeChange: (current, next) => updateRangeValue(next),
    afterChange: (current, prev) => updateCurrentSlide(current),
    variableWidth: true,
    responsive: [
      {
        breakpoint: BREAKPOINT,
        settings: {
          slidesToShow: SLIDES_TO_SCROLL_MOBILE,
          arrows: true,
          swipeToSlide: true,
        },
      },
    ],
  };

  const { foodLines = [] } = cartData || {};
  const successCallback = () => {
    if (foodLines.length > 0) {
      setReorderModalOpen(true);
    } else {
      dispatch(resetBasketAction());
      setQuickReorderModalOpen(true);
    }
  };

  const storeSuccessCallBack = (response, orderId) => {
    const storeDetails = _first(_get(response, 'response', {}), {});
    setStoreInfo(storeDetails);
    dispatch(getPostOrderAccepted({ tenantId, orderId, customerId }, successCallback));
  };

  const reorderBtnHandler = item => {
    !userParams?.localized && localisationStartAnalytics();
    setCurrentOrderInfo(item);
    const { store = {}, service = '', id: orderId = '' } = item || {};
    const { storeId = '' } = store || {};
    const data = [
      {
        storeId,
        channel: ChannelManager.channel,
        service,
      },
    ];
    dispatch(getReorderStoreStatus(data, tenantId, response => storeSuccessCallBack(response, orderId)));
    /* setting true value to reorderClick, to avoid the toast onclick of reorder button */
    sessionStorage.setItem('reorderClick', true);
  };

  const receiptModalProps = {
    id: 'ReceiptModal',
    role: 'dialog',
    modalTitleId: 'ReceiptModal',
    show: showReceiptModal,
    classNames: 'Base-modal Receipt-modal',
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: () => setReceiptModalOpen(false),
    modalTitle: 'ORDER RECEIPT',
    closeDataTestId: 'close-recipet-modal',
    autoFocus: true,
  };

  const receiptModalComponent = (
    <Modal {...receiptModalProps}>
      <div className='ReceiptModal'>
        <ReceiptComponent orderItem={orderDetails} />
      </div>
    </Modal>
  );

  const viewRecipetHandler = item => {
    const { id: orderId = '' } = item || {};

    dispatch(
      getPostOrderAccepted({ tenantId, orderId, customerId }, () => {
        setReceiptModalOpen(true);
      }),
    );
  };

  return (
    <>
      <div
        className={`pastorderCard-list ${getTernaryValue(
          sortData.length <= 4,
          'order-list',
          null,
        )} pastorderCard-list-in`}
      >
        <CarauselComp settings={settingsRecommendation} carousalRef={carousal}>
          {sortData &&
            sortData.map((item, index) => (
              <PastOrderCardComponentIn
                data-testid={`pastorder-list-card-test`}
                key={index}
                order={item}
                tenantReducerData={tenantReducerData}
                reorderBtnHandler={() => reorderBtnHandler(item)}
                viewRecipetHandler={() => viewRecipetHandler(item)}
              />
            ))}
        </CarauselComp>
        {sortData.length > 2 && (
          <div className='pastorder-slideContainer'>
            <input
              className='pastorder-slider'
              type='range'
              min='0'
              max={sortData.length - 1}
              value={rangeValue}
              id='myRange'
              data-testid='myRange'
              onChange={onUpdateRange}
            />
          </div>
        )}
      </div>

      {(reorderModalOpen || isQuickReorderModalOpen) && (
        <ReorderComponent
          storeInfo={storeInfo}
          currentOrderInfo={currentOrderInfo}
          reorderModalOpen={reorderModalOpen}
          setReorderModalOpen={setReorderModalOpen}
          isQuickReorderModalOpen={isQuickReorderModalOpen}
          setQuickReorderModalOpen={setQuickReorderModalOpen}
        />
      )}

      {showReceiptModal && receiptModalComponent}
    </>
  );
};

export default PastOrderListComponent;
